import { ContactType } from "../../../profile/domain/contact-type";
import { useEffect, useRef } from "react";
import { ContactChangeStatus } from "../../index";

export const ContactItem = ({ index, contact, updateContent, removeContact }) => {
    const { serviceType, title, content, status } = contact
    const { iconPath, placeholder } = ContactType[serviceType]
    const inputBox = useRef(null)

    useEffect(() => {
        if (status === ContactChangeStatus.DELETE) {
            return
        }

        const isValid = title.length > 0 && content.length > 0

        if (isValid) {
            inputBox.current.classList.remove("invalid")
        } else {
            inputBox.current.classList.add("invalid")
        }
    }, [status, title, content])

    const remove = () => {
        removeContact(serviceType, index)
    }
    const changeContent = (e) => {
        const newContent = e.target.value
        updateContent(serviceType, index, newContent)
    }

    if (status === ContactChangeStatus.DELETE) {
        return <></>
    }

    return (
        <div className="contact-item-container">
            <div className="contact-item-wrapper">
                <div className="icon-inner-wrapper">
                    <img alt={""} src={iconPath} className="contact-img" />
                    <span className="contact-name">{title}</span>
                </div>
                <button className="contact-item-del-btn" onClick={remove}>
                    <img alt={"삭제하기 버튼"} src="/assets/icons/trash_can.png" className="trash-can-img" />
                </button>
            </div>
            <input id="address" type="text" className="contact-input" placeholder={placeholder}
                autoComplete="off" value={content} onChange={changeContent}
                ref={inputBox} />
        </div>
    )
}